"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getOffsetTop = getOffsetTop;
exports.isOldIE = isOldIE;
exports.parent = parent;
exports.scrollPosition = scrollPosition;
exports.serialize = serialize;

/* eslint-disable */
function getOffsetTop(element) {
  // Set our distance placeholder
  var distance = 0; // Loop up the DOM

  if (element.offsetParent) {
    do {
      distance += element.offsetTop;
      element = element.offsetParent;
    } while (element);
  } // Return our distance


  return distance < 0 ? 0 : distance;
}

function parent(element, className) {
  while ((el = el.parentElement) && !el.classList.contains(className)) {
    ;
  }

  return element;
}

function scrollPosition() {
  return window.scrollY || window.scrollTop || document.getElementsByTagName("html")[0].scrollTop;
} // https://stackoverflow.com/questions/21825157/internet-explorer-11-detection


function isOldIE() {
  return navigator.userAgent.indexOf('MSIE') !== -1 || navigator.appVersion.indexOf('Trident/') > -1;
}

; // https://gomakethings.com/how-to-serialize-form-data-with-vanilla-js/

function serialize(form) {
  // Setup our serialized data
  var serialized = []; // Loop through each field in the form

  for (var i = 0; i < form.elements.length; i++) {
    var field = form.elements[i]; // Don't serialize fields without a name, submits, buttons, file and reset inputs, and disabled fields

    if (!field.name || field.disabled || field.type === 'file' || field.type === 'reset' || field.type === 'submit' || field.type === 'button') continue; // If a multi-select, get all selections

    if (field.type === 'select-multiple') {
      for (var n = 0; n < field.options.length; n++) {
        if (!field.options[n].selected) continue;
        serialized.push(encodeURIComponent(field.name) + "=" + encodeURIComponent(field.options[n].value));
      }
    } // Convert field data to a query string
    else if (field.type !== 'checkbox' && field.type !== 'radio' || field.checked) {
      serialized.push(encodeURIComponent(field.name) + "=" + encodeURIComponent(field.value));
    }
  }

  return serialized.join('&');
}

;